module.exports = __webpack_public_path__ + "static/lato-light-98d8cf792834c0bef59c2be99dc3533d.woff2";